import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.scss'],
})
export class PackageComponent implements OnInit, AfterViewInit {
  packageDetails: FormGroup;
  packageDataSource = new MatTableDataSource<any>();
  packageData: any;
  isValueChanged: boolean = false;

  columns: string[] = [
    'number',
    'packagingType',
    'packageLength',
    'packageWidth',
    'packageHeight',
    'packageWeight',
    'Action',
  ];

  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService
  ) {}

  ngOnInit(): void {
    this.packageDetails = this.fb.group({
      _id: '',
      config_id: 'packaging_types',
      customer_id: '',
      updated_by_username: '',
      updated_time: '',
      data: this.fb.array([]),
    });

    this.getPackageTypes();
  }

  AddNewPackageItem() {
    const control = this.packageDetails.get('data') as FormArray;
    control.insert(
      (this.packageDetails.get('data') as FormArray).controls.length + 1,
      this.addPackageGroup()
    );
    this.packageDataSource = new MatTableDataSource(control.controls);
  }

  DeletePackageItem(_formElement, i) {
    const control = this.packageDetails.get('data') as FormArray;
    control.removeAt(i);
    this.packageDataSource = new MatTableDataSource(
      (this.packageDetails.get('data') as FormArray).controls
    );
  }

  private addPackageGroup(): FormGroup {
    return this.fb.group({
      packageHeight: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,2})?$'),
        ])
      ),
      packageLength: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,2})?$'),
        ])
      ),
      packageWeight: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,2})?$'),
        ])
      ),
      packageWidth: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.1),
          Validators.pattern('^[0-9]+(.[0-9]{0,2})?$'),
        ])
      ),
      packagingType: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  getPackageFormControlId(id, control) {
    return (this.packageDetails.get('data') as FormArray).controls[id].get(control);
  }

  getPackageTypes() {
    this.configService.fetchConfig('packaging_types').then(res => {
      if (res.data) {
        this.packageDetails.patchValue(res);
        this.packageData = res;
        const PackageArray = res.data;
        (this.packageDetails.get('data') as FormArray).clear();
        if (PackageArray.length > 0) {
          PackageArray.forEach(item => {
            const packageGrp = this.addPackageGroup();
            packageGrp.patchValue(item);
            (this.packageDetails.get('data') as FormArray).push(packageGrp);
          });
          this.packageDataSource = new MatTableDataSource(
            (this.packageDetails.get('data') as FormArray).controls
          );
        }
      }
    });
  }

  savePackageConfig() {
    const config = this.packageDetails.value;
    config.config_id = 'packaging_types';
    this.configService.saveConfig(config).subscribe(() => {
      this.errorDialogService.openDialog('alert.configurationSuccess', false);
      this.isValueChanged = false;
      this.configService.putConfig(config.config_id, config.data);
    });
  }

  ngAfterViewInit() {
    this.isAnyValueUnChanged();
  }

  isAnyValueUnChanged() {
    setTimeout(() => {
      setTimeout(
        function () {
          this.packageDetails.valueChanges.subscribe(() => {
            this.isValueChanged = true;
          });
        }.bind(this),
        0
      );
    }, 1000);
  }
}
